import { createMultiStyleConfigHelpers } from "@chakra-ui/react"
import { formAnatomy } from "@chakra-ui/anatomy"
import headingTheme from "./heading"
import { textV4Variants } from "../../components/TextV4/TextV4"

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(formAnatomy.keys)

const activeLabelStyles = { transform: "scale(0.85) translateY(-24px)" }

const floating = definePartsStyle((props: any) => ({
  container: {
    position: "relative",

    _focusWithin: {
      label: activeLabelStyles,
    },

    "input:not(:placeholder-shown) + label, textarea:not(:placeholder-shown) ~ label":
      activeLabelStyles,

    label: {
      position: "absolute",
      top:
        props.size === "lg"
          ? "6px"
          : props.size === "sm"
          ? "1px"
          : "3px",
      left: 0,
      zIndex: 2,
      bg: "background",
      pointerEvents: "none",
      mx: 3,
      px: 1,
      my: 2,
      transformOrigin: "left top",
      transition: "all 0.2s ease",
      ...headingTheme?.sizes?.chakra_label_large,
      color: "onSurfaceVariant",
    },
  },
}))

const v4 = definePartsStyle((props: any) => ({
  container: {
    label: {
      ...textV4Variants.v4_dekstop_d_headline,
      marginBottom: '8px'
    },
    _invalid: {
      label: {
        color: "Jarivis-Danger-Border",
      },
    },
  },
  helperText: {
    ...textV4Variants.v4_dekstop_d_body,
    marginTop: '8px',
    _groupInvalid: {
      color: "Jarivis-Danger-Main",
    },
  },
}))

const Form = defineMultiStyleConfig({
  variants: {
    floating,
    v4,
  },
})

export default Form